import { render, staticRenderFns } from "./InternalRequests.vue?vue&type=template&id=96794f42&"
import script from "./InternalRequests.vue?vue&type=script&lang=js&"
export * from "./InternalRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports